// removed by extract-text-webpack-plugin
module.exports = {"teaser":"_2ySTx"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Teaser.scss
 ** module id = 111
 ** module chunks = 0
 **/